export default "__VITE_ASSET__Chr0CC$S__"